import $ from 'jquery';
import WindowUtil from "./windowUtil";
import Swiper, { Autoplay, Lazy } from 'swiper';

export default class FrontPage {
   constructor() {
      this.windowUtil = new WindowUtil();

      this.gallerySwiper = null;
      this.gallerySwiperMode = 'small';

      this.initGallerySwiper();
   }

   setupSwiper(modules, el, options) {
      if (!$(el).length) {
         return;
      }
      // configure Swiper to use modules
      Swiper.use(modules);
      // init Swiper:
      return new Swiper(el, options);
   }

   initGallerySwiper() {
      const swiperModlues = [Autoplay, Lazy];
      const swiperContainer = '[data-swiper-element="fpGallery"]';
      const swiperOptions = {
         autoplay: {
            delay: 5000,
         },
         speed: 600,
         loop: true,
         slidesPerView: 1.4,
         spaceBetween: 24,
         preloadImages: false,
         lazy: true,
         watchSlidesProgress: true,
         watchSlidesVisibility: true,
      };

      // mediaQuery初期チェック
      if (this.windowUtil.matchMediaQueryXsmall.matches || this.windowUtil.matchMediaQuerySmall.matches) {
         swiperOptions.slidesPerView = 1.4;
         this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
         this.gallerySwiperMode = 'small';
      } else if (this.windowUtil.matchMediaQueryMedium.matches) {
         swiperOptions.slidesPerView = 2.4;
         this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
         this.gallerySwiperMode = 'medium';
      } else {
         swiperOptions.slidesPerView = 3.4;
         swiperOptions.spaceBetween = 40;
         this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
         this.gallerySwiperMode = 'large';
      }

      // mediaQueryのchangeをウォッチする
      this.windowUtil.matchMediaQueryXsmall.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.gallerySwiper && this.gallerySwiperMode !== 'small') {
               this.gallerySwiper.destroy(false, true);
               swiperOptions.slidesPerView = 1.4;
               this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.gallerySwiperMode = 'small';
            }
         }
      });
      this.windowUtil.matchMediaQuerySmall.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.gallerySwiper && this.gallerySwiperMode !== 'small') {
               this.gallerySwiper.destroy(false, true);
               swiperOptions.slidesPerView = 1.4;
               this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.gallerySwiperMode = 'small';
            }
         }
      });
      this.windowUtil.matchMediaQueryMedium.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.gallerySwiper && this.gallerySwiperMode !== 'medium') {
               this.gallerySwiper.destroy(false, true);
               swiperOptions.slidesPerView = 2.3;
               this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.gallerySwiperMode = 'medium';
            }
         }
      });
      this.windowUtil.matchMediaQueryLarge.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.gallerySwiper && this.gallerySwiperMode !== 'large') {
               this.gallerySwiper.destroy(false, true);
               swiperOptions.slidesPerView = 3.4;
               swiperOptions.spaceBetween = 40;
               this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.gallerySwiperMode = 'large';
            }
         }
      });
      this.windowUtil.matchMediaQueryXlarge.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.gallerySwiper && this.gallerySwiperMode !== 'large') {
               this.gallerySwiper.destroy(false, true);
               swiperOptions.slidesPerView = 3.4;
               swiperOptions.spaceBetween = 40;
               this.gallerySwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.gallerySwiperMode = 'large';
            }
         }
      });
   }
};
